import { METRIC_DEFINITIONS } from '../../../shared/constants/metrics';
import useAnimatedCounter from '../hooks/useAnimatedCounter';

const DashboardTeamCard = ({ team, metrics, index, onShowDetail }) => {
  const overall =
    METRIC_DEFINITIONS.reduce((sum, { key }) => sum + metrics[key], 0) /
    METRIC_DEFINITIONS.length;

  const animatedOverall = useAnimatedCounter(overall, 1100 + index * 80);
  const teamColor = team.color || '#3bbddb';
  const stepsCount = team.stepsCount ?? team.steps?.length ?? 0;

  return (
    <article
      className="dashboard-team-card"
      style={{
        animationDelay: `${0.08 + index * 0.07}s`,
        '--team-accent': teamColor,
      }}
    >
      <div className="dashboard-team-card-accent" aria-hidden="true" />

      <header className="dashboard-team-card-header">
        <div className="dashboard-team-score-ring">
          <svg viewBox="0 0 36 36" className="dashboard-team-score-svg">
            <path
              className="dashboard-team-score-bg"
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
            <path
              className="dashboard-team-score-fill"
              strokeDasharray={`${animatedOverall}, 100`}
              d="M18 2.0845 a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831"
            />
          </svg>
          <span className="dashboard-team-score-value">{animatedOverall.toFixed(0)}%</span>
        </div>

        <div className="dashboard-team-card-title">
          <span className="dashboard-team-rank">#{index + 1}</span>
          <h4>{team.name}</h4>
          <p className="dashboard-team-meta">{stepsCount} шагов процесса</p>
        </div>
      </header>

      <div className="dashboard-team-metrics">
        {METRIC_DEFINITIONS.map(({ key, title, detailColor }) => (
          <div key={key} className="dashboard-metric-row">
            <div className="dashboard-metric-row-head">
              <span className="dashboard-metric-label">{title}</span>
              <span className="dashboard-metric-percent" style={{ color: detailColor }}>
                {metrics[key].toFixed(1)}%
              </span>
            </div>
            <div className="dashboard-metric-track">
              <div
                className="dashboard-metric-fill"
                style={{
                  width: `${metrics[key]}%`,
                  background: `linear-gradient(90deg, ${detailColor}cc, ${detailColor})`,
                  animationDelay: `${0.3 + index * 0.07}s`,
                }}
              />
            </div>
          </div>
        ))}
      </div>

      <footer className="dashboard-team-card-footer">
        <button
          type="button"
          className="dashboard-detail-btn"
          onClick={() => onShowDetail(team)}
        >
          <span>Подробнее</span>
          <span className="dashboard-detail-arrow">→</span>
        </button>
      </footer>
    </article>
  );
};

export default DashboardTeamCard;
